module.exports = __webpack_public_path__ + "img/stock5.b383a615.png";